import {
  functionalUpdate,
  SortingState,
  TableOptions,
} from '@tanstack/react-table';
import { useMemo, useState } from 'react';
import { MinRowsForUsingVirtuoso } from 'src/components/Accordions';
import { ColumnResizingContextProvider } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { MarketplacePaymentLineWithSaleAndEventInfo } from 'src/hooks/useGetMarketplacePaymentLineTableData';
import { useMarketplacePaymentLinesTableColumnsConfig } from 'src/tables/MarketplacePaymentLinesTable/useMarketplacePaymentLinesTableColumnsConfig';
import { Table } from 'src/tables/Table';
import { MarketplacePaymentLinesTableColumnId } from 'src/utils/columns/marketplacePaymentLines/marketplacePaymentLinesColumnsUtils.types';

const getRowId = (
  row: MarketplacePaymentLineWithSaleAndEventInfo | null,
  index: number
) => (row?.id ?? index).toString();

interface PaymentsTableProps {
  tableData: MarketplacePaymentLineWithSaleAndEventInfo[] | null;
}

export const MarketplacePaymentLinesTable = ({
  tableData,
}: PaymentsTableProps) => {
  const paymentsTableColumnConfig =
    useMarketplacePaymentLinesTableColumnsConfig();
  const [sorting, setSorting] = useState<SortingState>([]);

  const options: Partial<
    TableOptions<MarketplacePaymentLineWithSaleAndEventInfo | null>
  > = useMemo(
    () => ({
      data: tableData ?? [],
      columns: Object.values(paymentsTableColumnConfig),
      state: {
        sorting,
        columnPinning: {
          right: [MarketplacePaymentLinesTableColumnId.Actions],
        },
      },
      getRowId: getRowId,
      onSortingChange: (sortingUpdaterFn) => {
        const newSortVal = functionalUpdate(sortingUpdaterFn, sorting);
        setSorting(newSortVal);
      },
      sortingFns: {},
    }),
    [tableData, paymentsTableColumnConfig, sorting]
  );

  return (
    <ColumnResizingContextProvider>
      <Table
        options={options}
        tableLayout="fixed"
        withOuterPadding={true}
        useVirtuoso={
          !!(tableData && tableData.length > MinRowsForUsingVirtuoso)
        }
        usePaginationFooter={false}
        roundBorders={true}
      />
    </ColumnResizingContextProvider>
  );
};
